// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import styled from "styled-components";

type Props = WidgetProps;

const Hr = styled.hr`
    border: 0;
    border-top: ${pxToRem(3)} solid ${getColor("common.border")};
`;

const Seperator: FC<Props> = () => {
    return <Hr />;
};

const widgetModule: WidgetModule = {
    component: Seperator,
    definition: {
        group: "Basic",
        icon: "minus",
    },
};

export default widgetModule;
